import { createAsyncThunk } from "@reduxjs/toolkit";
import { clearLocalStorageExceptKeys } from "src/services/clearLocalStorageExceptKeys";
import { axiosInstance } from "../../axios.config";
import { api } from "../../config";
import { onLogin } from "src/shared/funcForMobile";

// Action Types
export const TRY_LOGIN_SUCCESS = 'TRY_LOGIN_SUCCESS';
export const TRY_LOGIN_FAIL = 'TRY_LOGIN_FAIL';
export const CLEAR_LOGIN = "CLEAR_LOGIN";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const UPD_LOGIN = 'UPD_LOGIN';
export const LOGOUT = 'LOGOUT';
export const SHOW_PRELOADER = "SHOW_PRELOADER";
export const HIDE_PRELOADER = "HIDE_PRELOADER";
export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_FAILD = "LOGGED_FAILD";
export const NO_REG = "NO_REG";
export const BLACK_LIST = "BLACK_LIST";

const notRemovedItemsLocalStore = ["language_name"];


// Action Creators

export const tryLogin = (phone) => async (dispatch) => {
  try {
    console.log("tryLogin", phone);
    const response = await axiosInstance.post(api + "/driver/sign", {
      phone,
      branchId: 2,
    });
    localStorage.setItem("login", phone);
    dispatch({
      type: TRY_LOGIN_SUCCESS,
      payload: response.data,
    });

  } catch (error) {
    const serverData = error.response?.data;
    dispatch({
      type: TRY_LOGIN_FAIL,
      payload: {
        errorKey: serverData?.Data || "login_failed",
      },
    });
  }
};

export const clearLogin = () => ({
  type: CLEAR_LOGIN,
});

export const logout = () => {
  clearLocalStorageExceptKeys(notRemovedItemsLocalStore);
  return (dispatch) => {
    dispatch({
      type: LOGOUT,
    });
    dispatch({
      type: HIDE_PRELOADER,
    });
  };
};

export const updLogin = (value) => ({
  type: UPD_LOGIN,
  payload: value,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const confirmLoginCode = createAsyncThunk(
  "driver/confirmLoginCode",
  async ({ phone, code }, { dispatch, rejectWithValue }) => {
    localStorage.setItem("login", phone);
    dispatch({ type: SHOW_PRELOADER });

    try {
      const response = await axiosInstance.post(api + "/driver/confirm-sign", {
        phone,
        code,
        branchId: 2,
      });

      if (response?.status === 200 || response?.status === 204) {
        localStorage.setItem("accessToken", response?.data.accessToken);
        localStorage.setItem("refreshToken", response?.data.refreshToken);
        dispatch({
          type: LOGGED_IN,
          payload: true,
        });

        onLogin();
      }

      dispatch({ type: HIDE_PRELOADER });
    } catch (error) {
      if (
        error.response?.data?.Data === "user_in_blacklist" ||
        error.response?.data?.Data === "user_blocked"
      ) {
        dispatch({ type: BLACK_LIST });
      } else if (error.response?.data?.Data === "invalid_confirmation_code") {
        dispatch({
          type: LOGGED_FAILD,
          payload: {
            loginStatus: false,
            message: "invalid_confirmation_code",
            phone,
            wrongPass: true,
          },
        });
      } else {
        dispatch({
          type: NO_REG,
          payload: phone,
        });
      }

      dispatch({ type: HIDE_PRELOADER });
      return rejectWithValue(error);
    }
  }
);

